Service = App.loadClass 'core::Angular/Service'

class exports.UserService extends Service
    constructor: (@http, @window) ->
        return

    getLoggedInUser: () =>
        @http.post('backend/username-dropdown/get-logged-in-user').then (jsr) =>
            return @handleJsonResponse jsr

    getSafelinkUser: () =>
        @http.post('backend/username-dropdown/get-safe-link-user').then (jsr) =>
            return @handleJsonResponse jsr

    getBackgroundOptions: () =>
        @http.post('backend/username-dropdown/get-background-options').then (jsr) =>
            return @handleJsonResponse jsr

    getStates: () =>
        @http.post('backend/username-dropdown/get-states').then (jsr) =>
            return @handleJsonResponse jsr

    getLocales: () =>
        @http.post('backend/username-dropdown/get-locales').then (jsr) =>
            return @handleJsonResponse jsr

    saveBackground: (user) =>
        return @http.post 'backend/username-dropdown/save-background',
            title: user.title
            expertise_ids: user.expertise_ids
            professions_id: user.professions_id
            experience: user.experience

    saveContact: (pretend, user, additionalValidation = false) =>
        return @http.post 'backend/username-dropdown/save-contact',
            pretend: pretend
            user: user
            additionalValidation: additionalValidation


    setLocale: (locale_id) =>
        return @http.post 'backend/username-dropdown/set-locale', { locale_id: locale_id }


    viewPrivacyPolicy: () =>
        @window.open 'backend/username-dropdown/privacy-policy',  '_blank'
        return true

    updateUnconfirmedNumber: (phone) =>
        return @http.post 'backend/grower/sms-confirmation/update-unconfirmed-number',
            phone: phone

    phoneNumberConfirmed: () =>
        return @http.get 'backend/grower/sms-confirmation/phone-number-confirmed'
